<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {PiggyMechanicType} from "@/modules/redactor/models/smart-offer/bundle-piggy/PiggyMechanicType";

export default {
  name: "r-piggy-mechanic-type",
  props: {
    model: VueTypes.instanceOf(PiggyMechanicType),
    label: VueTypes.string.def("Mechanic Type:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return PiggyMechanicType.getValues();
    }
  }
}
</script>